import type { JSX, ReactNode } from 'react';
import { createContext, useState } from 'react';

export type Variant = string;

export type ContextValue = {
	noSelectionMadeError: boolean;
	setNoSelectionMadeError: (value: boolean) => void;
	setUserInteracted: (value: boolean) => void;
	userInteracted: boolean;
	variant?: Variant;
};

export const SunriseHoldoutExperimentContext = createContext<ContextValue>({
	userInteracted: false,
	setUserInteracted: () => {},
	setNoSelectionMadeError: () => {},
	noSelectionMadeError: false,
});

export function SunriseHoldoutExperimentContextProvider({
	children,
	variant,
}: {
	children: ReactNode;
	variant: string | undefined;
}): JSX.Element {
	const [userInteracted, setUserInteracted] = useState(false);
	const [noSelectionMadeError, setNoSelectionMadeError] = useState(false);

	return (
		<SunriseHoldoutExperimentContext.Provider
			value={{
				noSelectionMadeError,
				setNoSelectionMadeError,
				setUserInteracted,
				userInteracted,
				variant,
			}}
		>
			{children}
		</SunriseHoldoutExperimentContext.Provider>
	);
}
